<template>
  <div class="entryBtnGroup">
    <slot></slot>
  </div>
</template>

<script>
export default {
  data() {
    return {};
  }
};
</script>

<style lang="scss" scoped>
.entryBtnGroup {
  max-width: 1200px;
  padding-left: 14px;
  padding-right: 14px;
  margin-left: auto;
  margin-right: auto;
  display: flex;
  flex-direction: row;
  flex-wrap: wrap;
  align-items: center;
}
.entryBtnGroup .entryBtn {
  margin-left: 5%;
  margin-bottom: 36px;
}
</style>